import { render, staticRenderFns } from "./LinkParceiro.vue?vue&type=template&id=2d73abd0&scoped=true"
import script from "./LinkParceiro.vue?vue&type=script&lang=js"
export * from "./LinkParceiro.vue?vue&type=script&lang=js"
import style0 from "./LinkParceiro.vue?vue&type=style&index=0&id=2d73abd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73abd0",
  null
  
)

export default component.exports